export default "__VITE_ASSET__cAN9KXgZ__"